import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import { Table, Tooltip, Button, Form, Select, Input, DatePicker } from "antd";
import dayjs from "dayjs";
import eye from "../../../images/icons/eye.svg";
import "../../../styles/paginador.scss";
import CustomButton from "../../../components/Genericos/CustomButton/CustomButton";
import { svgVolver } from "../../../images/icons/svg/svgVolver";
import "./styles.scss";
import TituloPrincipal from "../../../components/Genericos/TituloPrincipal/TituloPrincipal";
import ResolucionApi from "../../../services/api/resolucion-api";
import { formatearRut } from "../../../utils/formatting";

const HistorialRegistroResoluciones
  = () => {
    // ************** useStates ***************

    const [formRegistroResoluciones] = useForm();

    //*** PAGINACION TABLA ***/

    const [pagination, setPagination] = useState({
      defaultPageSize: 10,
      current: 1,
      pageSizeOptions: ["10", "20", "30"],
      showSizeChanger: true,
    });

    const onChangeTable = (pagination, filters, sorter) => {
      setPagination({
        current: pagination.current,
        pageSizeOptions: ["10", "20", "30"],
        showSizeChanger: true,
      });
    };

    const tiposBusqueda = [
      { value: 0, label: "Faena" }, { value: 1, label: "Rut Solicitante" }, { value: 2, label: "Razón Social Solicitante" }
    ]

    const [selectedTipoBusqueda, setSelectedTipoBusqueda] = useState(-1);
    const [disabledBotonBuqueda, setDisabledBotonBuqueda] = useState(true);
    const [disabledBotonLimpiarBuqueda, setDisabledBotonLimpiarBuqueda] = useState(true);

    useEffect(() => {
      if (dataSource.length == 0)
        ResolucionApi.getAllRegistrosResoluciones().then((res) => {
          const response = res.data;
          setDataSource(response);
        }).catch((error) => {
          console.error(
            `Error al solicitar datos`,
            error
          );
          // Puedes manejar el error según tus necesidades
          return null;
        });
    }, [pagination]);

    /***** Data *********/
    const [dataSource, setDataSource] = useState([]);


    // **************** Hooks *****************
    window.parent.postMessage(`resetScroll`, "*");
    const navigate = useNavigate();

    // *************** Set Data ***************
    const loading = useSelector((state) => state.microfrontStorage.loading);


    const columns = [
      {
        title: "Fecha Emisión",
        dataIndex: "fechaResolucion",
        render: (n, record) => {
          return dayjs(record.fechaResolucion).isValid()
            ? dayjs(record.fechaResolucion).format("DD-MM-YYYY")
            : "";
        },
        sorter: (a, b, c) => compareDates(a, b, c),
        sortDirections: ["ascend", "descend", 'ascend'],
      },
      {
        title: "RUT Solicitante",
        dataIndex: "rutSolicitante",
        render: (n, record) => { return formatearRut(record.rutSolicitante) },
        sorter: (a, b) => a.rutSolicitante?.localeCompare(b.rutSolicitante),
        sortDirections: ["ascend", "descend", 'ascend'],
      },
      {
        title: "Nombre o Razón Social",
        dataIndex: "nombreRazonSocial",
        sorter: (a, b) => a.nombreRazonSocial?.localeCompare(b.nombreRazonSocial),
        sortDirections: ["ascend", "descend", 'ascend'],
      },
      {
        title: "Faena",
        dataIndex: "nombreFaena",
        sorter: (a, b) => a.nombreFaena?.localeCompare(b.nombreFaena),
        sortDirections: ["ascend", "descend", 'ascend'],
      },
      {
        title: "N° Resolución",
        dataIndex: "numeroResolucion",
        sorter: (a, b) => a.numeroResolucion?.localeCompare(b.numeroResolucion),
        sortDirections: ["ascend", "descend", 'ascend'],
      },

      {
        title: <span style={{ fontWeight: 100 }}>Ver</span>,
        dataIndex: "key",
        align: "center",
        width: "10%",
        CSS: "font-weight:100;",

        render: (n, record) => {
          return (
            <>
              <Tooltip title="Descargar">
                <Button
                  type="link"
                  onClick={(e) => handleVerResolucion(e, record)}
                >
                  <img src={eye} alt="" />
                </Button>
              </Tooltip>
            </>
          );
        },
      },
    ];

    //*** ORDENAMIENTO FECHAS TABLA ***/

    const compareDates = (a, b, c) => {
      const nullComparator = c === "descend" ? -1 : 1;
      if (a.fechaResolucion === null && b.fechaResolucion === null) {
        return 0;
      }
      if (a.fechaResolucion === null) {
        return nullComparator;
      }
      if (b.fechaResolucion === null) {
        return -nullComparator;
      }

      const dateA = dayjs(a.fechaResolucion);
      const dateB = dayjs(b.fechaResolucion);
      return dateA.isBefore(dateB) ? -1 : 1;
    };

    const onChangeNombreFaena = () => {
      setDisabledBotonBuqueda(formRegistroResoluciones.getFieldValue('nombreFaena').length == 0);
    }

    const onChangeRutEmpresa = (e) => {
      //debugger;
      setDisabledBotonBuqueda(formRegistroResoluciones.getFieldValue('rutEmpresaSolicitante').length == 0);
      if (!disabledBotonBuqueda) {
        const rutEmpresaSolicitante = formRegistroResoluciones.getFieldValue("rutEmpresaSolicitante")
        formRegistroResoluciones.setFieldValue('rutEmpresaSolicitante', formatearRut(rutEmpresaSolicitante));
      }
    }

    const onChangeNombreRazonSocial = () => {
      setDisabledBotonBuqueda(formRegistroResoluciones.getFieldValue('razonSocialEmpresaSolicitante').length == 0);
    }

    const handleChangeTipoBusqueda = (tipoBusquedaId) => {
      setSelectedTipoBusqueda(tipoBusquedaId);
    }

    const handleVerResolucion = (e, record) => {
      ResolucionApi.getResolucionByNumeroResolucion(record.numeroResolucion.replaceAll("/", "_"), record.numeradorSerieDocumental).then((res) => {
        var byteCharacters = atob(res.data.data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);

        // Crear un enlace de descarga
        var a = document.createElement('a');
        a.href = fileURL;
        a.download = res.data.nombreArchivo; // nombre predeterminado del archivo
        document.body.appendChild(a);
        a.click();

        // Eliminar el enlace después de la descarga
        document.body.removeChild(a);
        URL.revokeObjectURL(fileURL);
      }).catch((error) => {
        console.error(
          `Error al solicitar datos`,
          error
        );
        // Puedes manejar el error según tus necesidades
        return null;
      });
    }

    const filtarPorBusqueda = (tipoBusquedaId) => {
      switch (tipoBusquedaId) {
        case 0:
          const nombreFaena = formRegistroResoluciones.getFieldValue("nombreFaena");
          ResolucionApi.getRegistrosResoluciones({ nombreFaena: nombreFaena }).then((res) => {
            const response = res.data;
            setDataSource(response);
            setDisabledBotonLimpiarBuqueda(false);
          }).catch((error) => {
            console.error(
              `Error al solicitar datos`,
              error
            );
            // Puedes manejar el error según tus necesidades
            return null;
          });
          break;
        case 1:
          const rutEmpresa = formRegistroResoluciones.getFieldValue("rutEmpresaSolicitante").replace('.', '').replace('.', '').replace("-", "");
          ResolucionApi.getRegistrosResoluciones({ rutSolicitante: rutEmpresa }).then((res) => {
            const response = res.data;
            setDataSource(response);
            setDisabledBotonLimpiarBuqueda(false);
          }).catch((error) => {
            console.error(
              `Error al solicitar datos`,
              error
            );
            // Puedes manejar el error según tus necesidades
            return null;
          });
          break;
        case 2:
          const nombreRazonSocial = formRegistroResoluciones.getFieldValue("razonSocialEmpresaSolicitante");
          ResolucionApi.getRegistrosResoluciones({ razonSocialSolicitante: nombreRazonSocial }).then((res) => {
            const response = res.data;
            setDataSource(response);
            setDisabledBotonLimpiarBuqueda(false);
          }).catch((error) => {
            console.error(
              `Error al solicitar datos`,
              error
            );
            // Puedes manejar el error según tus necesidades
            return null;
          });
          break;
        default:
          break;
      }

    }

    const limpiarBusqueda = () => {
      ResolucionApi.getAllRegistrosResoluciones().then((res) => {
        const response = res.data;
        setDataSource(response);
        setSelectedTipoBusqueda(-1);
        formRegistroResoluciones.setFieldValue('tipoBusqueda', null);
        formRegistroResoluciones.setFieldValue('nombreFaena', "");
        formRegistroResoluciones.setFieldValue('rutEmpresaSolicitante', "");
        formRegistroResoluciones.setFieldValue('razonSocialEmpresaSolicitante', "");
        setDisabledBotonLimpiarBuqueda(true);
        setDisabledBotonBuqueda(true);
      }).catch((error) => {
        console.error(
          `Error al solicitar datos`,
          error
        );
        // Puedes manejar el error según tus necesidades
        return null;
      });

    }

    // ************** Component ***************

    return (
      <>
        <Container className="mt-3 principal">
          <TituloPrincipal textoInicial="Jornada Excepcional" texto="/ Listado Nacional de Resoluciones" />
          <Form
            layout="vertical"
            className="formulario"
            onSubmit={(e) => e.preventDefault()}
            form={formRegistroResoluciones}
            requiredMark={false}
          >
            <Row className="pt-2 pb-4" >
              <Col xs={12} md={12} lg={12}>
                <div className="descripcion-registro">
                  En cumplimiento a lo dispuesto en el artículo 32 del Decreto N° 48 de fecha 29/09/2023, a continuación,
                  encontrará copia de las resoluciones de jornadas excepcionales emitidas por la Dirección del Trabajo desde el 01/10/2024
                </div>
              </Col>
            </Row>
            <div className="busqueda">
              <Row className="pt-2 pb-2">
                <Col xs={12} md={4} lg={4}>
                  <Form.Item
                    className="busqueda-selector"
                    name="tipoBusqueda"
                    label="Buscar por"
                  >
                    <Select
                      dropdownStyle={{ fontFamily: "Roboto" }}
                      placeholder="Selecciona"
                      onChange={handleChangeTipoBusqueda}
                      options={tiposBusqueda}
                    ></Select>
                  </Form.Item>
                </Col>
                {(selectedTipoBusqueda == 0) &&
                  <Col xs={8} md={6} lg={6}>
                    <Form.Item
                      name="nombreFaena"
                      className="nombre-faena"
                      label={<>Nombre de Faena&nbsp;&nbsp;</>}
                    >
                      <Input
                        maxLength={300}
                        placeholder="Faena"
                        onChange={(e) => onChangeNombreFaena()}
                      />
                    </Form.Item>
                  </Col>
                }

                {(selectedTipoBusqueda == 1) &&
                  <Col xs={8} md={6} lg={6}>
                    <Form.Item
                      name="rutEmpresaSolicitante"
                      className="rut-empresa-solicitante"
                      label={<>Rut Empresa Solicitante&nbsp;&nbsp;</>}
                    >
                      <Input
                        maxLength={12}
                        placeholder="123456789-K"
                        onChange={(e) => onChangeRutEmpresa()}
                      />
                    </Form.Item>
                  </Col>
                }

                {(selectedTipoBusqueda == 2) &&
                  <Col xs={8} md={6} lg={6}>
                    <Form.Item
                      name="razonSocialEmpresaSolicitante"
                      className="razon-social-empresa-solicitante"
                      label={<>Nombre Razón Social&nbsp;&nbsp;</>}
                    >
                      <Input
                        maxLength={200}
                        placeholder="Razón Social Empresa Solicitante"
                        onChange={(e) => onChangeNombreRazonSocial()}
                      />
                    </Form.Item>
                  </Col>
                }

                {(selectedTipoBusqueda !== -1) &&
                  <Col xs={4} md={2} lg={2}>
                    <Button
                      type="primary"
                      className="btnAzul btn-form"
                      disabled={disabledBotonBuqueda}
                      style={{ borderRadius: "4px", width: "114px", height: "40px", fontSize: "16px", marginTop: "35px" }}
                      onClick={() => {
                        filtarPorBusqueda(selectedTipoBusqueda);
                      }}
                    >
                      Buscar
                    </Button>
                  </Col>
                }
              </Row>
              <Row className="pt-1 pb-2">
                <Col xs={6} md={3} lg={3} >
                  <Button
                    type="primary"
                    className="btnAzul btn-form"
                    disabled={disabledBotonLimpiarBuqueda}
                    style={{ borderRadius: "4px", width: "160px", height: "40px", fontSize: "16px", marginTop: "0px" }}
                    onClick={() => {
                      limpiarBusqueda();
                    }}
                  >
                    Limpiar búsqueda
                  </Button>
                </Col>
              </Row>
            </div>

            <Row className="w-100 col-12 mx-auto overflow-auto justify-content-center mt-4">
              <Table
                id="tbl-registro-resoluciones"
                key="key_ReclamosListado"
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                rowKey={(record) => record.resolucionId}
                onChange={(a, b, c) => onChangeTable(a, b, c)}
                pagination={pagination}
                showSorterTooltip={false}
              />
            </Row>

            <Row>
              <Col
                xs={10}
                sm={12}
                className="mx-auto d-flex justify-content-between mt-5 mb-5"
              >
                <CustomButton
                  type="outlined"
                  className="btnBlanco btn-form"
                  svgIcon={svgVolver}
                  iconPosition={"left"}
                  onClick={() => {
                    window.location.href = "https://www.dt.gob.cl/"
                  }}
                >
                  {"Volver"}
                </CustomButton>
              </Col>
            </Row>
          </Form>
        </Container>
      </>
    );
  };
export default HistorialRegistroResoluciones;
